import React from 'react'

import './QbDisplay.css'

const QbDisplay = ({ value, title, contentStyle }) => (
  <div className="qb-display-container">
    {title ? <span>{title}</span> : null }
    <div className="qb-display-content" style={contentStyle}>
      <span>{value}</span>
    </div>
  </div>
)

export default QbDisplay

export function copyTextFromDisplay(text) {
  const span = document.getElementsByClassName('qb-display-content').item('span')
  const area = document.createElement('textarea')
  area.value = text
  span.appendChild(area)
  area.select()
  document.execCommand('copy')
  span.removeChild(area)
}



// WEBPACK FOOTER //
// ./src/components/shared/QbDisplay/QbDisplay.js